import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { QUERY_KEYS } from "./querykeys";

type OrgAddMemberResponseType = ResponseType<null>;


function useCreateDemoProjectQuary(organisationId: string) {
  return useQuery<
    AxiosResponseAndError<OrgAddMemberResponseType>["response"],
    AxiosResponseAndError<OrgAddMemberResponseType>["error"]
  >({
    queryKey: [QUERY_KEYS.DemoProject],
    queryFn: async () => await ApiRequest.get(`${requestURLs.organisation}/demo-project/${organisationId}`),
    enabled: false,
    retry:0,
  });
}
export default useCreateDemoProjectQuary;
